// InventoryList.js
import React, { useState, useEffect, useCallback } from 'react';
import { inventoryAPI, warehousesAPI } from '../../services/api';
import toast from 'react-hot-toast';

export default function InventoryList() {
  const [inventory, setInventory] = useState([]);
  const [warehouses, setWarehouses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [warehouseId, setWarehouseId] = useState('');

  useEffect(() => { warehousesAPI.list().then(r => setWarehouses(r.data)).catch(() => {}); }, []);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const res = await inventoryAPI.list({ search, warehouse_id: warehouseId, limit: 100 });
      setInventory(res.data.inventory);
    } catch { toast.error('Failed to load inventory'); }
    finally { setLoading(false); }
  }, [search, warehouseId]);

  useEffect(() => { load(); }, [load]);

  return (
    <div>
      <div className="page-header"><div><h1>Stock Overview</h1><p className="subtitle">Current inventory across all warehouses</p></div></div>
      <div className="card">
        <div className="card-body" style={{ paddingBottom: 0 }}>
          <div className="search-bar">
            <div className="search-input-wrapper">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
              <input placeholder="Search products..." value={search} onChange={e => setSearch(e.target.value)} />
            </div>
            <select className="form-select" style={{ width:'auto', minWidth:180 }} value={warehouseId} onChange={e => setWarehouseId(e.target.value)}>
              <option value="">All Warehouses</option>
              {warehouses.map(w => <option key={w.id} value={w.id}>{w.name}</option>)}
            </select>
          </div>
        </div>
        <div className="table-container">
          {loading ? <div className="loading-container"><div className="spinner" /></div> : (
            <table>
              <thead><tr><th>Product</th><th>SKU</th><th>Schedule</th><th>Manufacturer</th><th style={{textAlign:'right'}}>Total Stock</th><th style={{textAlign:'right'}}>Available</th><th style={{textAlign:'right'}}>Reorder Level</th><th>Earliest Expiry</th><th>Status</th></tr></thead>
              <tbody>
                {inventory.map(p => {
                  const isLow = Number(p.total_stock) <= Number(p.reorder_level);
                  const expiry = p.earliest_expiry ? new Date(p.earliest_expiry) : null;
                  const daysToExpiry = expiry ? Math.ceil((expiry - new Date()) / (1000*60*60*24)) : null;
                  return (
                    <tr key={p.id}>
                      <td><div style={{fontWeight:600}}>{p.name}</div>{p.generic_name && <div className="text-xs text-secondary">{p.generic_name}</div>}</td>
                      <td className="td-mono">{p.sku}</td>
                      <td>{p.drug_schedule !== 'none' ? <span className="badge badge-red">Sch. {p.drug_schedule}</span> : <span className="badge badge-gray">General</span>}</td>
                      <td className="text-secondary">{p.manufacturer_name || '-'}</td>
                      <td className="td-amount" style={{ fontWeight:700, color: isLow ? 'var(--danger)' : 'inherit' }}>{p.total_stock}</td>
                      <td className="td-amount">{p.available_stock}</td>
                      <td className="td-amount text-secondary">{p.reorder_level}</td>
                      <td>{expiry ? <span style={{ color: daysToExpiry <= 90 ? 'var(--danger)' : daysToExpiry <= 180 ? 'var(--accent)' : 'inherit' }}>{expiry.toLocaleDateString('en-IN',{month:'short',year:'2-digit'})} ({daysToExpiry}d)</span> : '-'}</td>
                      <td>{isLow ? <span className="badge badge-red">Low Stock</span> : <span className="badge badge-green">OK</span>}</td>
                    </tr>
                  );
                })}
                {inventory.length === 0 && <tr><td colSpan={9} className="text-center text-secondary" style={{padding:40}}>No inventory data</td></tr>}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
}
